export const MAX_FILE_SIZE_BYTES = 25 * 1024 * 1024; // 25 MB
export const ACCEPTED_FILE_EXTENSIONS = [".ppt", ".pptx", ".pdf"];
export const ACCEPTED_MIME_TYPES = new Set([
  "application/pdf",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
]);
